'use strict';

angular.module('controllers')
	.directive('mdFocus', ['$timeout', function($timeout) {
		var directive = {
			restrict: 'A',
			link: function(scope, element, attributes){
				$timeout(function(){
					angular.element(element[0].querySelector("input.md-input")).bind("focus", function(){
						$timeout(function() {
							scope.$eval(attributes.mdFocus);
						}, 100);
					});
				},0);
			}
		};

		return directive;
	}]);
